document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('sound-toggle');
  const audio = document.getElementById('bg-music');

  if (!btn || !audio) {
    console.log('Sound elements not found');
    return;
  }

  audio.volume = 0.25;
  audio.muted = false;
  btn.textContent = '🔊';

  btn.addEventListener('click', async () => {
    try {
      if (audio.paused) {
        await audio.play();
        btn.textContent = '🔇';
        localStorage.setItem('homeSound', 'on'); // ← aquí estaba otro bug
        console.log('Audio playing');
      } else {
        audio.pause();
        btn.textContent = '🔊';
        localStorage.setItem('homeSound', 'off');
        console.log('Audio paused');
      }
    } catch (err) {
      console.error('Audio play blocked:', err);
    }
  });

  if (localStorage.getItem('homeSound') === 'on') {
    audio.play();
    btn.textContent = '🔇';
  }
});
